import React from 'react';

export type Props = {
    size: string;
};

export const CameraIcon = ({ size }: Props) =>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 600 400"
        className={ `device-class-icon ${size}` }
    >
        <path
            d="M478.2 37.39C482.26 37.39 485.55 40.68 485.55 44.74C485.55 109.91 485.55 298.04 485.55 363.21C485.55 367.27 482.26 370.56 478.2 370.56C409.06 370.56 209 370.56 139.86 370.56C135.8 370.56 132.51 367.27 132.51 363.21C132.51 298.04 132.51 109.91 132.51 44.74C132.51 40.68 135.8 37.39 139.86 37.39C209 37.39 409.06 37.39 478.2 37.39Z"
            fill="#b9b9b9" fillOpacity="1" stroke="#000000" strokeWidth="15" strokeOpacity="1"
        />
        <path
            d="M406 211.55C406 265.07 362.55 308.52 309.03 308.52C255.51 308.52 212.06 265.07 212.06 211.55C212.06 158.03 255.51 114.58 309.03 114.58C362.55 114.58 406 158.03 406 211.55Z"
            fill="#000000" fillOpacity="1" stroke="#000000" strokeWidth="11" strokeOpacity="1"
        />
        <path
            d="M456.06 90.91C456.06 107.22 442.82 120.45 426.52 120.45C410.21 120.45 396.97 107.22 396.97 90.91C396.97 74.6 410.21 61.36 426.52 61.36C442.82 61.36 456.06 74.6 456.06 90.91Z"
            fill="#ff0000" fillOpacity="1" stroke="#000000" strokeWidth="3" strokeOpacity="1"
        />
        <path
            d="M244.2 198C260.6 178.53 283.4 166.13 312.6 160.8C312.47 159.6 311.28 152.33 309.03 139C272.52 141 249.31 161.33 239.4 200C241 199.87 242.6 199.2 244.2 198Z"
            fill="#ffffff" fillOpacity="1"
        />
        <path
            d="M377.43 225.55C361.03 245.02 338.23 257.42 309.03 262.75C309.16 263.95 310.35 271.22 312.6 284.55C349.11 282.55 372.32 262.22 382.23 223.55C380.63 223.69 379.03 224.35 377.43 225.55Z"
            fill="#ffffff" fillOpacity="1"
        />
    </svg>
;